import { variablesToFieldsInfo } from '@microservices/wiskey-react-components'

import { ObjectFieldDTO } from '@types'

export const getColumnsObjectHeaderScriptHint = (data: {
  columnsObjectFields: ObjectFieldDTO[]
}) => {
  const { columnsObjectFields } = data

  const variables = [
    {
      name: 'srcObj',
      type: [
        {
          name: 'item',
          type: !columnsObjectFields?.length
            ? 'any'
            : columnsObjectFields.map(field => {
                return {
                  name: field.name,
                  type: field.valueType,
                }
              }),
        },
      ],
    },
  ]

  return {
    examples: [
      {
        title: 'Qualification name in column header (JS)',
        description: 'Returns the qualification name for display in the column header.',
        code: 'return srcObj.item.qual_name',
      },
    ],
    variables,
    fieldsInfo: variablesToFieldsInfo(variables),
  }
}
